import { render, staticRenderFns } from "./CompositesHistory.vue?vue&type=template&id=32c9af56&scoped=true&"
import script from "./CompositesHistory.vue?vue&type=script&lang=js&"
export * from "./CompositesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9af56",
  null
  
)

export default component.exports